import { connect } from 'react-redux';

import Component from './D2AAnnualGrowthTable.component';
import { getStudentsList, getGrowthMatrix, clearGrowthMatrix } from '../+store/aToF';
import { getStudentsListApi } from '../+store/aToF/aToF.api';

// The request that produced the report on screen, so a baseline swap re-rows
// the matrix against exactly the same columns (campus, filters, score option).
const pickReportRequest = (reportData) => {
  const action = reportData && reportData.originalAction;
  if (!action) return null;
  const { schoolYear, assessmentsInfo, campusDistrictNumber, filters, option } = action;
  return { schoolYear, assessmentsInfo, campusDistrictNumber, filters, option };
};

const mapStateToProps = (state) => {
  const { aToF } = state.modules.AtoF;
  // Same roster year the drill-down popup (Common/StudentsList) uses.
  const year = aToF.filters.schoolYear;
  const { roster } = state.modules.StudentRoster.studentRoster;
  const { reportData } = aToF;
  return {
    profile: state.modules.Auth.auth.profile,
    roster: year && roster ? roster[year - 1] : null,
    avatars: state.modules.StudentRoster.studentRoster.avatars,
    growthMatrix: aToF.growthMatrix,
    reportRequest: pickReportRequest(reportData),
    campusName: reportData ? reportData.districtOrCampusName : null,
    campusNumber: reportData ? reportData.districtOrCampusNumber : null,
    assessmentList: state.modules.Assessments.assessments.assessmentList,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleGetStudentsList: (orgId, path, rowLabel, indicatorLabel) => {
    dispatch(getStudentsList(orgId, path, rowLabel, indicatorLabel));
  },
  // Reads every cell's student ids for one subject in a single RTDB call
  // (aToFStudents/{uid}/d2aAnnualGrowth/{subject}, or .../growthMatrix/{subject}
  // once the rows are swapped) for the faces and names views.
  loadMatrixStudents: (orgId, path) => getStudentsListApi(orgId, path),
  onSelectBaseline: (reportRequest, baseline) => {
    dispatch(getGrowthMatrix({ reportRequest, baseline }));
  },
  onResetBaseline: () => {
    dispatch(clearGrowthMatrix());
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
